import { Chip } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { IssueTicketImportance } from 'src/graphql/generated/graphql';

export const ImportanceField = ({
  importance,
}: {
  importance: IssueTicketImportance;
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'issue.ticket.list.columns',
  });
  switch (importance) {
    case IssueTicketImportance.Low:
      return <Chip label={t('importance-low')} />;
    case IssueTicketImportance.Medium:
      return <Chip label={t('importance-medium')} color="warning" />;
    case IssueTicketImportance.High:
      return <Chip label={t('importance-high')} color="error" />;
  }
};
